/**
 * Stable key for a messaging contact.
 *
 * A player and that player's guardian share a `contactId` — a guardian has no record of its own,
 * so it is identified by the player's id — which means the type has to be part of the key or
 * selecting one would silently deselect the other.
 */
export const contactKey = (contact: {
  contactId: string;
  contactType: string;
}): string => `${contact.contactType}:${contact.contactId}`;
